import { FieldType } from '../../../../models/field-type';
import { FormConfig } from '../../../../models/form-config';
import { OwnerDataConsts } from '../../../../../core/consts/owner-data.consts';
import { getDrivingLicenseIssueYears } from '../../../../utils/driving-license-years';
import { OwnerDataSectionConfig } from '../owner-data-section.config';
import { PredefinedValuesService } from '../../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import { Validator } from '../../../../models/validator.enum';
import { changeDateByYears } from '../../../../../core/utils/utils';
import {MaterialDatepickerType} from '../../../../enums/material-datepicker-type.enum';
import {OwnerDataConfig} from '../owner-data.config';
import {OwnerDataStateService} from '../../../../../core/services/impl/section-services/owner-data/owner-data-state.service';

export class AdditionalDriverConfig extends OwnerDataSectionConfig {

  public readonly DRIVER_MIN_AGE = 16;
  public readonly DRIVER_MAX_AGE = 120;

  constructor(public predefined: PredefinedValuesService,
              public stateService: OwnerDataStateService) {
    super();
  };


  public createAdditionalDriverConfig(): FormConfig {
    const formConfig =  <FormConfig> {
      formKey: 'CO_OWNER_DATA_SECTION',
      fieldsConfig: [
        {
          fieldKey: OwnerDataConsts.BIRTH_DATE,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.birthDate',
          type: FieldType.DateField,
          validators: [Validator.REQUIRED],
          displayInPreviewMode: true,
          materialDateFieldConfig: {
            minDate: changeDateByYears(new Date(), -this.DRIVER_MAX_AGE),
            maxDate: changeDateByYears(new Date(), -this.DRIVER_MIN_AGE),
            startView: 'multi-year'
          },
          analyticsConfig: {
            skipFieldValue: true
          }
        },
        {
          fieldKey: OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.drivingLicenseIssueYear',
          type: FieldType.DateField,
          validators: [Validator.REQUIRED],
          displayInPreviewMode: true,
          materialDateFieldConfig: {
            startView: 'multi-year',
            type: MaterialDatepickerType.YEAR,
            startAt: this.stateService.DRIVING_LICENSE_ISSUE_YEAR_START_YEAR,
            datepickerToggleIcon: 'arrow_drop_down',
            hideCalendarPeriodButton: true,
            initMinDateWithStartAt: false,
            minDate: Math.min(...getDrivingLicenseIssueYears(OwnerDataConfig.START_YEAR)) + '',
            maxDate: Math.max(...getDrivingLicenseIssueYears(OwnerDataConfig.START_YEAR)) + '',
            manualInputAllowed: true,
            readonly: false,
          }
        },
        {
          fieldKey: OwnerDataConsts.DRIVING_LICENSE_ISSUE_MONTH,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.drivingLicenseIssueMonth',
          type: FieldType.Select,
          displayInEditableMode: false,
          displayInPreviewMode: true,
          validators: [],
          options: {
            item: 'key',
            label: { label: 'label' },
            items: []
          },
          select: {
            dropdownPosition: 'bottom',
            multiple: false,
            searchable: true
          }
        },
      ]
    };


    formConfig.fieldsConfig.forEach(fieldConfig => {
      this.predefined.addPredefinedValue(
        fieldConfig,
        this.predefined.values,
        formConfig.formKey,
        fieldConfig.fieldKey
      )
    });

    return this.createConfig(formConfig)
  }
}
